// We'll put all our re-used styled components for Shared items in here.
import styled, { css } from 'styled-components';

export const ComponentTitle = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.5;
  h3 {
    font-size: 2.2rem;
    display: flex;
    flex-wrap: wrap;
  }
  .subText {
    z-index: 1;
    height: 26px;
    line-height: 30px;
    padding-left: 5px;
    font-size: 1.4rem;
    color: var(--color-primary);
  }
  ${props => (props.$buttonType === 'button'
    ? `
    button {
      cursor: pointer;
      font-size: 1.6rem;
      height: 35px;
      align-self: end;
      margin: 22px 0 22px auto
    }
    `
    : `
    button {
      cursor: pointer;
      font-size: 1.6rem;
      height: 26px;
      color: var(--color-link);
      border: none;
      background: none;
      align-self: end;
      margin: 22px 0 22px auto
    }
    button:hover {
      color: var(--color-secondary);
    } `
  )}
  `;

export const DataGridColumn = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  grid-auto-flow: dense;
  border-top: 1px solid var(--color-priority-default);
  border-left: 1px solid var(--color-priority-default);
  margin-right: -1px;
  > div:nth-child(odd) {
    background: var(--color-row-even);
  }
  > div:nth-child(even) {
    background: var(--color-bg);
  }
  > div {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid var(--color-priority-default);
    border-right: 1px solid var(--color-priority-default);
    &.highlight {
        background: #ffffd5;
      }
    > div {
      padding: 4px;
      flex: 1;
      white-space: nowrap;
      &:first-child {
        line-height: 1.8;
        font-weight: bold;
        border-right: 1px solid var(--color-data-border);
      }
      &:last-child {
        line-height: 2;
        font-size: 1.4rem;
      }
    }
  }
`;

export const DataGridRow = styled.div`
  display: grid;
  grid-template-rows: repeat(auto-fit, minmax(320px, 1fr));
  grid-auto-flow: column;
  grid-gap: 1%;
`;

export const DataDescription = styled.span`
  color: var(--color-primary);
  font-size: 1.4rem;
`;

export const Icon = styled.span`
  display: inline-block;
  margin-right: 0.25em;
  height: ${props => (props.$iconSize ? props.$iconSize : '1.25em')};
  width: ${props => (props.$iconSize ? props.$iconSize : '1.25em')};
  vertical-align: text-top;
  ${props => (
    props.$useMask ? `
      &:before {
        height: 100%;
        width: 100%;
        content: '';
        display: block;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
        -webkit-mask-size: contain;
        mask-size: contain;
        -webkit-mask-image: ${props.icon};
        mask-image: ${props.icon};
        -webkit-mask-position: center right;
        mask-position: center right;
        background-color: ${props.color || 'var(--color-primary)'};
      }
      &.alt:before {
        -webkit-mask-image: ${props.$altIcon || props.icon};
        mask-image: ${props.$altIcon || props.icon};
      }
      ${props.onClick || props.$useHoverStyle ? `
        &:hover {
          cursor: pointer;
          &:before {
            background-color: ${props.$hoverColor || 'hsl(var(--color-secondary-hue), var(--color-secondary-saturation), calc(var(--color-secondary-lightness) + 12%))'};
          }
        }
      ` : ''}
    ` : `
      background-image: ${props.icon};
      background-repeat: no-repeat;
    `
  )}
`;

export const FlexBoxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => (props.gap ? `${props.gap}px` : '10px')};
  ${props => (props.$fullWidth ? `width: 100%;` : ``)}
  > * {
    flex: 1;
    max-width: 100%;
  }
`;

export const StyledFeatureNotifications = styled.section`
  width: calc(100% - 0.7em);
  padding: 0;
  margin: 0.3em;
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  gap: 0.3em;
  z-index: 100;
  .feature {
    font-size: 0.9em;
    .content-wrapper {
      display: flex;
      flex-wrap: wrap;
      gap: 1em;
      align-items: center;
      a {
        font-weight: 600;
      }
      button.dismiss-feature-notification {
        margin-left: 1em;
      }
      .content {
        flex: 1;
        gap: 0.3em;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
    }
    border-radius: var(--radius-small);
    padding: 0.3em;
    background-color: var(--color-primary-triadic2);
    color: var(--color-white);
    display: flex;
    justify-content: space-between;
  }
`;

export const CenteredTextArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DataBoxWrap = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 370px;
    padding: var(--padding-databox);
    border: 2px solid transparent;
    background: ${props => (props.$type === 'white' ? 'var(--color-bg)' : 'var(--color-databox-bg)')};
    position: relative;
    border-radius: ${props => (props.$inset ? 'var(--radius-main)' : 'var(--radius-large)')};
    ${props => (props.$type === 'white' ? `
      .d3Legend .legendWrap, .d3Legend button {
        background: var(--color-whiteish);
      }
    ` : `
      .d3Legend .legendWrap, .d3Legend button {
        background: var(--color-bg);
      }
    `)}
    .titleWrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      ${props => (props.$buttonIcon ? `
        align-items: baseline;
      ` : `
      `)}
      .title {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        color: var(--color-text);
        font-weight: bold;
        font-size: 1.4rem;
        min-height: 32px;
        line-height: 1;
        ${props => (props.$buttonIcon ? `
          max-width: calc(100% - 30px);
        ` : `
        `)}
      }
      .subtitle {
        color: var(--color-light-label);
        padding-left: 10px;
        font-weight: 100;
        font-size: 1.4rem;
      }
    }
    &.warning {
      padding: 0;
      .titleWrapper {
        padding: 20px 20px 10px;
        background-color: var(--color-warning);
        color: var(--color-white);
        display: flex;
        justify-content: space-between;
        border-top-left-radius: var(--radius-large);
        border-top-right-radius: var(--radius-large);
      }
      &.collapsed .titleWrapper {
        padding-bottom: 20px;
      }
      .title {
        color: inherit;
        font-size: 1.5rem;
        font-weight: bold;
      }
      .addButton {
        color: var(--color-white)
      }
    }
    .dataBoxBody {
      position: relative;
      max-height: 10000px;
      height: 100%;
      opacity: 1;
      transition: var(--transition-base);
    }
    &.collapsed {
      overflow: hidden;
      .titleWrapper {
        margin: 0;
      }
      .dataBoxBody {
        max-height: 0px !important;
        opacity: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        overflow: hidden;
        transition: var(--transition-base);
      }
    }
`;

export const DataBoxList = styled.div`
  -moz-column-width: ${props => (props.$fullWidth ? 'unset' : '280px')};
  -webkit-column-width: ${props => (props.$fullWidth ? 'unset' : '280px')};
  column-width: ${props => (props.$fullWidth ? 'unset' : '280px')};
  gap: 5px;
  ${props => (props.$fullWidth ? `
    &.x0, &.x1 {
      dl {
        &:nth-child(even) {
          background: var(--color-row-even);
        }
      }
    }
  ` : `
  `)}
  &.x1, &.x3, &.x5, &.x7, &.x9, &.x11 {
    dl {
      &:nth-child(even) {
        background: var(--color-row-even);
      }
    }
  }
  &.x2 dl {
    &:nth-child(4n+0), &:nth-child(4n+1) {
      background: var(--color-row-even);
    }
  }
  &.x4 dl {
    &:nth-child(8n+1), &:nth-child(8n+3), &:nth-child(8n+6), &:nth-child(8n+8) {
      background: var(--color-row-even);
    }
  }
  &.x6 dl {
    &:nth-child(12n+2), &:nth-child(12n+4), &:nth-child(12n+6),
    &:nth-child(12n+7), &:nth-child(12n+9), &:nth-child(12n+11) {
      background: var(--color-row-even);
    }
  }
  &.x8 dl {
    &:nth-child(16n+2), &:nth-child(16n+4), &:nth-child(16n+6), &:nth-child(16n+8),
    &:nth-child(16n+9), &:nth-child(16n+11), &:nth-child(16n+13), &:nth-child(16n+15) {
      background: var(--color-row-even);
    }
  }
  &.x10 dl {
    &:nth-child(20n+2), &:nth-child(20n+4), &:nth-child(20n+6), &:nth-child(20n+8), &:nth-child(20n+10),
    &:nth-child(20n+11), &:nth-child(20n+13), &:nth-child(20n+15), &:nth-child(20n+17), &:nth-child(20n+19) {
      background: var(--color-row-even);
    }
  }
  dl, dt, dd {
    margin: 0;
    padding: 0;
  }
  dl {
    line-height: 1;
    display: flex;
    align-items: stretch;
    flex-wrap: nowrap;
    max-width: 100%;
    background: var(--color-row);
    overflow: hidden;
  }
  ${props => (props.$useHoverStyle ? `
    dl {
      &:hover {
        background: var(--color-row-hover) !important;
      }
    }
  ` : `
  `)}
  dt, dd {
    padding: 5px;
    min-width: 140px;
  }
  dt {
    text-transform: uppercase;
    font-size: 1rem;
    color: var(--color-light-label);
    flex: 1;
  }
  dd {
    border-left: 1px solid var(--color-data-border);
    word-break: break-word;
    font-size: 1.4rem;
    flex: 2;
  }
`;

export const TabbedComponentWrap = styled.section`
  padding-top: ${props => (props.$smallTabs ? '10' : '20')}px;
  ${props => (props.$sideMode ? 'display: flex;' : '')}
`;

const tabHorizontal = css`
  position: relative;
  outline: none;
  list-style: none;
  padding: 10px 16px 7px;
  text-align: center;
  cursor: pointer;
  margin-left: 2px;
  margin-right: 2px;
  line-height: 1.4;
  background-color: transparent;
  flex: ${props => (props.align === 'center' ? '1' : '0')};
  &.withIcon {
    padding: 10px 7px 7px;
  }
  &:before {
    background-color: var(--color-tab-inactive);
    transition: var(--transition-base);
    border-radius: var(--radius-large) var(--radius-large) 0 0;
  }
  > div, > span, > a {
    top: 0px;
    padding: 0;
    transition: top .15s ease;
  }
  &:hover {
    &:before {
      top: -8px;
    }
    > div, > span, > a {
      top: -4px;
    }
  }
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  > div span {
    margin-top: -3px;
  }
  &[tabindex='${props => props.tabIndex}'] {
    &.withIcon {
      padding: 7px;
    }
    &:before {
      background-color: ${props => props.fill || 'var(--color-whiteish)'};
      top: -8px;
      cursor: default;
    }
    > div, > span, > a {
      top: 0;
      cursor: default;
    }
  }
  .tabWithIconWrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
`;

const tabVertical = css`
  @media only screen and (max-width: 775px) {
    /* on narrow screens, switch to horizontal mode - will be stuck to top */
    ${tabHorizontal}
  }
  @media only screen and (min-width: 775px) {
    flex: 1;
    display: block;
    cursor: pointer;
    padding: 10px 20px 10px 10px;
    outline: none;
    overflow: hidden;
    white-space: nowrap;
    text-align: right;
    background-color: var(--color-tab-inactive);
    transition: width .35s ease;
    width: 94%;
    border-radius: var(--radius-main) 0  0 var(--radius-main);
    > div, > span, > a {
      left: 0px;
      transition: left .15s ease;
    }
    ${props => (props.$sticky ? `
      text-align: left;
      padding: 0;
      a, > div {
        color: var(--color-bg);
        padding: 5px 7px;
        font-size: 1.4rem;
        display: block;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
        font-weight: normal;
        div {
          padding: 0;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          transition: var(--transition-base);
        }
      }
    ` : ``)}
    &:before {
      left: 100%;
      right: 0;
      background: var(--color-bg);
      opacity: 0;
      transition: left .15s ease;
    }
    &:hover {
      transition: width .35s ease;
      width: 100%;
      &:before {
        opacity: 0.5;
        left: 0px;
      }
      > div, > span, > a {
        left: -4px;
      }
    }
    &[tabindex='${props => props.tabIndex}'] {
      cursor: default;
      width: 100%;
      &:before {
        left: 0;
        opacity: 1;
        background-color: ${props => props.fill || 'var(--color-whiteish)'};
      }
      a, > span, > div {
        top: 0;
        left: 0;
        cursor: default;
      }
    }
  }
`;

export const TabbedComponentTabsWrap = styled.div`
  nav {
    ${props => (props.$sideMode ? `
      width: calc(100% - 10px);
      @media only screen and (max-width: 775px) {
        width: 100%;
      }
  ` : ``)}
  }
  ul {
    ${props => (props.$sideMode ? `
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      width: 100%;
      min-width: 130px;
    ` : `
      display: flex;
      font-size: 1.3rem;
      line-height: 1.3;
      margin: 0;
      padding: 0;
      ${props.align === 'center' ? `
        justify-content: space-evenly;
      ` : ``}
      ${props.align === 'left' ? `
        justify-content: flex-start;
      ` : ``}
      ${props.align === 'right' ? `
        justify-content: flex-end;
      ` : ``}
    `)}
    li a, li div, li span {
      position: relative;
      z-index: 1;
    }
    li a, li div {
      color: var(--color-heading);
    }
    a {
      display: block;
    }
    li[tabindex='${props => props.tabIndex}'] {
      a, > span, > div {
        font-weight: bold;
      }
    }
  }
  li {
    position: relative;
    &:before {
      z-index: 0;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: block;
      content: '';
    }
    ${props => (props.$sideMode
    ? tabVertical
    : tabHorizontal
  )}
  }
  ${props => (props.$sideMode ? `
    flex: 1;
    max-width: 200px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  ` : ``)}
  ${props => (props.$sideMode && props.$sticky ? `
    position: fixed;
    z-index: 9;
    height: 100vh;
    width: 20%;
    max-width: 320px;
    top: 80px;
    padding: 8px 0 0 0 !important;
    overflow-y: auto;
    background: hsl(var(--color-secondary-hue), var(--color-secondary-saturation), calc(var(--color-secondary-lightness) - 2%));
    transition: var(--transition-base);
  },
  ` : ``)}
  &.validate {
    nav {
      li {
        &:before {
          background-color: hsl(var(--color-grey-hue), var(--color-grey-saturation), calc(var(--color-grey-lightness) + 7%));
        }
        &.isActiveTab {
          &:before {
            background-color: var(--color-grey);
          }
        }
        .tab-title {
          color: var(--color-dark-grey);
        }
      }
      li.valid {
        &:before {
          background-color: var(--color-sage);
        }
        .tab-title {
          color: var(--color-forest);
        }
      }
      li.invalid {
        &:before {
          background-color: var(--color-warning-bg);
        }
        .tab-title {
          color: var(--color-warning);
        }
      }
    }
  }
`;

export const TabbedComponentContentWrap = styled.div`
  max-width: 100%;
  ${props => (props.$sideMode ? `
    flex: 1;
    background: var(--color-bg);
    border-radius: 0 var(--radius-main) var(--radius-main) var(--radius-main);
  ` : `
    padding: 0 10px;
    border-radius: 0 0 var(--radius-main) var(--radius-main);
  `)}
  ${props => (props.$sideMode && props.$sticky ? `
    padding-left: min(20%, 320px);
  ` : `
    max-width: ${props.$child ? 'calc(100% - 200px)' : 'calc(100vw- 200px)'};
  `)}
  ${props => (props.fill ? `background-color: ${props.fill};` : ``)}
  &.validate {
    display: flex;
    flex-direction: column;
  }
  .navigate-tabs-bar {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1em;
  }
`;

export const FileListWrapper = styled.div`
  display: flex;
  ${props => (props.size === 'small' ? `
    flex-wrap: wrap;
    cursor: default;
  ` : `
    width: 100%;
    flex-direction: column;
  `)}
  > div:nth-child(even) {
    background-color: ${props => (props.type === 'white' ? 'var(--color-air)' : 'var(--color-bg)')};
  }
`;

export const FileRowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 0.1em;
  .files-action-bar {
    visibility: hidden !important;
  }
  .hover {
    position: absolute;
    right: 0px;
    background: transparent;
    top: 0px;
    width: 4px;
    height: 4px;
  }
  &:hover {
    background-color: hsl(var(--color-primary-hue), var(--color-primary-saturation), calc(var(--color-primary-lightness) + 45%)) !important;
    padding-right: ${props => (props.$canEdit || props.$canDelete || props.timestamp
    ? `${(props.$canEdit ? 20 : 0) + (props.$canDelete ? 20 : 0) + (props.timestamp ? 20 : 0)}px`
    : 0
  )};
    .files-action-bar {
      visibility: visible !important;
    }
  }
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 100%;
  .file-link {
    max-width: 100%;
  }
`;

export const FileImageListWrapper = styled.div`
  display: grid;
  padding: 10px;
  grid-auto-rows: 1f;
  padding: unset;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
`;

export const FileImageRowWrapper = styled.div`
  margin: 2px;
  flex: 1;
  position: relative;
  .files-action-bar {
    visibility: hidden !important;
  }
  &:hover {
    .files-tag-list {
      max-width: ${props => (props.$canEdit || props.$canDelete || props.timestamp
    ? `calc(100% - ${(props.$canEdit ? 20 : 0) + (props.$canDelete ? 20 : 0) + (props.timestamp ? 20 : 0)}px)`
    : '100%'
  )}
    };
    .files-action-bar {
      visibility: visible !important;
      position: absolute;
      right: 1em;
      bottom: 0.5em;
    }
  }
`;

export const FileImageRowLink = styled.a`
  display: block;
  padding-bottom: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  line-height: 0;
  font-size: 0;
  border-radius: var(--radius-main);
  border: 1px solid var(--color-grey);
  filter: opacity(60%);
  &:hover {
    filter: opacity(100%);
  }
`;

export const HistoryListWrapper = styled.div`
  color: var(--color-text);
  font-size: 1.4rem;
  align-items: baseline;
  display: flex;
  flex-direction: column;
  .history-list {
    display: flex;
    flex-flow: column;
    width: 100%;
    /* header, footer, databox top & bottom padding, databox title height, show more button height */
    max-height: calc(100vh - var(--height-header) - var(--height-footer) - var(--padding-databox) - var(--padding-databox) - 52px - 20px);
    overflow: auto;
  }
  .history-title-wrapper {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;
    .history-timestamp {
      background-color: var(--color-note-header);
      border: 1px solid var(--color-hr);
      border-radius: var(--radius-main);
      font-weight: 800;
      padding: 0.2em 0.5em 0 0.5em;
      width: max-content;
      line-height: 1.7em;
    }
    .history-title {
      background-color: var(--color-stone);
      border: 1px solid var(--color-hr);
      border-radius: var(--radius-main);
      font-size: 1.2rem;
      font-weight: 800;
      padding: 0.2em;
      width: max-content;
      line-height: 1.7em;
    }
  }
  .history-arrow-container {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: var(--color-hr);
    margin: 0 0 0 1.5em;
    padding: 0.6em 0 0.6em 1em;
    position: relative;
    .history-arrow {
      color: var(--color-hr);
      position: absolute;
      left: -0.5em;
      top: -0.75em;
    }
  }
  .history-description {
    background-color: var(--color-bg-alt);
    border: 1px solid var(--color-hr);
    font-size: 0.9em;
    padding: 0.3em;
    line-height: 1.5;
    word-break: break-word;
    border-radius: var(--radius-main);
    .history-owner {
      font-weight: 800;
      word-break: break-all;
    }
  }
`;

export const TaskGridCardHeader = styled.div`
  align-items: center;
  background-color: var(--color-air);
  border-radius: calc(var(--radius-large) - 2px);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  justify-content: space-between;
  padding: 1em 1em 0.5em 1em;
  position: relative;
  .task-actions {
    display: flex;
    align-items: flex-end;
    position: absolute;
    top: calc(-50% + 2.25em);
    right: 1em;
    > div {
      height: 32px;
      display: flex;
      align-items: flex-end;
    }
  }
`;

export const GenericCard = styled.div`
  padding-bottom: 0.3em;
  position: relative;
  border-radius: var(--radius-medium);
  border-width: 2px;
  border-color: var(--color-stoplight-green);
  overflow: hidden;
  line-height: 1em;
  vertical-align: middle;
  max-height: fit-content;
  color: var(--color-text);
  .generic-card-header {
    background-color: var(--color-disabled);
    display: flex;
    justify-content: space-between;
    padding: 0.3em;
    .generic-card-title {
      font-weight: bold;
      font-size: 1.8rem;
    }
  }
  .generic-card-body {
    padding: 0.3em 0.3em 0.3em .3em;
    font-size: 1.4rem;
    background-color: white;
    border-radius: var(--radius-medium);
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;

export const TaskGridCardWrapper = styled.div`
  padding-bottom: 1em;
  position: relative;
  ${props => (props.$isSubCard ? `
    border-color: transparent;
    background-color: var(--color-bg);
    height: fit-content;
  ` : `
    border-color: var(--color-task-border);
    background-color: var(--color-task-bg);
  `)}
  border-radius: var(--radius-large);
  border-width: 2px;
  border-style: solid;
  overflow: hidden;
  .task-footer .file-list {
    flex: 1;
    margin-top: 0.2em;
    margin-left: 0.2em;
  }
  .task-footer .task-files .file-list-wrapper .file-row,
  .task-body-data-list button {
    background-color: transparent;
  }
  .task-title {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    font-weight: bold;
    font-size: 1.6rem;
    color: var(--color-dark-grey);
    min-height: 32px;
    line-height: 1;
  }
  .task-header {
    background-color: var(--color-task-header);
    .task-title {
      color: var(--color-bg);
    }
  }
  ${props => (props.status === 'approved' ? `
    transition: var(--transition-base);
    border-color: var(--color-task-approved-border);
    background-color: var(--color-task-approved-bg);
    .task-header {
      background-color: var(--color-task-approved-header);
      .task-title {
        color: var(--color-forest);
      }
    }
  ` : ``)}
  ${props => (props.status === 'rejected' ? `
    transition: var(--transition-base);
    background-color: var(--color-task-rejected-bg);
    border-color: var(--color-task-rejected-border);
    .task-header {
      background-color: var(--color-task-rejected-header);
      .task-title {
        color: var(--color-white);
      }
    }
  ` : ``)}
  ${props => (props.status === 'pended' ? `
    transition: var(--transition-base);
    background-color: var(--color-task-pended-bg);
    border-color: var(--color-task-pended-border);
    .task-header {
      background-color: var(--color-task-pended-header);
      .task-title {
        color: var(--color-notice);
      }
    }
  ` : ``)}
    ${props => (props.status === 'will_not_complete' ? `
    transition: var(--transition-base);
    background-color: var(--color-task-will-not-complete-bg);
    border-color: var(--color-task-will-not-complete-border);
    .task-header {
      background-color: var(--color-task-will-not-complete-header);
            .task-title {
        color: var(--color-task-will-not-complete-text);
      }
    }
  ` : ``)}
  ${props => (props.$isSubCard ? `
    transition: var(--transition-base);
    background-color: var(--color-bg) !important;
    border-color: transparent !important;
    .task-header {
      background-color: var(--color-bg) !important;
      .task-title {
        color: var(--color-forest) !important;
      }
    }
  ` : ``)}
  .task-body, .task-footer {
    overflow: hidden;
    max-height: 2000px;
    opacity: 1;
    transition: var(--transition-base);
  }
  .task-footer {
    padding: 0 1em;
    margin-bottom: 1em;
  }
  &.collapsed {
    .task-body, .task-footer {
      max-height: 0px;
      min-height: 0px !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      margin-bottom: 0 !important;
      opacity: 0;
    }
  }
`;

export const Legend = styled.div`
  width: 100%;
  position: relative;
  /* box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1) inset; */
  ${props => (props.position === 'right' ? `
    height: 100%;
    flex: 1;
    max-height: 166px;
    overflow: auto;
  ` : ``)}
  .legendWrap {
    overflow: auto;
    border-radius: var(--radius-small);
    max-height: calc(100vh - var(--height-header) - 16px);
    ${props => (props.position === 'bottom' ? `
      display: grid;
      grid-template-columns: repeat(auto-fill, calc(100% / 3));
      grid-gap: 0.5em 0;
      padding: 0.4em;
      ${props.count === 1 ? 'grid-template-columns: repeat(auto-fill, 100%);' : ''}
      ${props.count % 2 === 0 ? 'grid-template-columns: repeat(auto-fill, calc(100% / 2));' : ''}
      ${props.count > 9 ? `
        overflow: auto;
        grid-template-columns: repeat(auto-fill, calc(100% / 3));
      ` : ``}
    ` : `
      display: flex;
      flex-direction: column;
      padding: ${props.$preText ? `5px 15px 15px 15px` : `15px`};
      gap: 4px;
    `)}
  }
  .preText {
    flex: 100%;
    font-style: italic;
    font-size: 1.2rem;
    padding: 5px 15px;
    line-height: 1;
  }
  .cell {
    flex: 1;
    position: relative;
    min-height: fit-content;
    line-height: 1.1;
    font-size: 1.1rem;
    white-space: pre-line;
    word-break: break-word;
    display: flex;
    padding: 0 0.2em;
    gap: 0.4em;
    display: flex;
    align-items: baseline;
  }
  button {
    position: absolute;
    right: -2px;
    top: -14px;
    padding: 0 8px;
    text-align: left;
    height: 16px;
    line-height: 16px;
    border-radius: var(--radius-small) var(--radius-small) 0 0;
  }
  .legendIcon {
    min-width: 1em;
    height: 1em;
    position: absolute;
    border-radius: 2px;
  }
  .legendItemTitle {
    margin-left: 1.25em
  }
`;

export const TicketBubble = styled.div`
  border-radius: 1.5em;
  font-size: 0.75em;
  min-height: 1.5em;
  min-width: fit-content;
  padding: 0.25em;
  margin-left: 0;
  margin-bottom: 1em;
  text-align: center;
  color: white;
  background-color: var(--color-warning);
  ${props => (props.notifications > 0 ? `
  animation: swell 0.5s ease-in-out, fadeIn 0.5s ease-in-out;
  ` : '')}
  ${props => (props.$wrapperStyle ? props.$wrapperStyle : '')}
`;

export const Notice = styled.div`
  ${props => (props.$noHeader ? `
    margin-top: 10px;
  ` : `
    margin-top: 30px;
    &:before {
      content: "NOTICE:";
      font-weight: bold;
      position: absolute;
      left: 0;
      top: -30px;
    }
  `)}
  ${props => (props.size === 'sm' ? `
    font-size: 1.2rem;
    line-height: 1.5rem;
    margin-top: 15px;
    &:before {
      top: -20px;
    }
  ` : ``)}
  padding: 10px;
  position: relative;
  color: var(--color-warning);
  border: 1px solid var(--color-warning);
  border-radius: var(--radius-main);
  background-color: var(--color-warning-bg);
  ${props => (props.type === 'notice' ? `
    color: var(--color-notice);
    border-color: var(--color-notice);
    background-color: var(--color-notice-bg);
  ` : ``)}
  ${props => (props.type === 'success' ? `
    color: var(--color-healthy);
    border-color: var(--color-healthy);
    background-color: var(--color-healthy-bg);
  ` : ``)}
  ul {
    padding-left: 30px;
    margin: 0;
  }
`;

export const FilterBar = styled.div`
  width: auto;
  min-width: 250px;
  display: flex;
  padding: 10px 5px;
  flex-wrap: wrap;
  gap: 5px;
  background-color: var(--color-filter-bar);
  border-radius: var(--radius-main);
  ${props => (props.$fixedAlways ? `
    margin: 0px;
    box-sizing: border-box;
    min-height: auto;
    transition: all 0.2s ease 0s;
    position: fixed;
    top: calc(49px + var(--padding-header) + var(--padding-header));
    left: 0px;
    right: 0px;
    z-index: 9;
    border-bottom: 1px solid hsl(45, 15%, calc(85% + 30%));
    box-shadow: rgba(0, 0, 0, 0.05) 0px 7px 5px -5px;
    border-radius: unset;
  ` : `
    position: relative;
    margin-bottom: 5px;
  `)}
  > *:not(.spinner) {
    flex: 1;
    min-width: 280px;
    max-width: 560px;
  }
  .clearFiltersBtn, .searchIcon {
    font-size: 1.1rem;
    line-height: 1.5;
    padding: 2px;
    margin: 0 5px;
    align-self: flex-end;
  }
  .clearFiltersBtn {
    height: auto;
    margin-left: 0;
    min-width: fit-content;
    max-width: fit-content;
    align-self: flex-end;
    margin-bottom: 4px;
  }
`;

export const ErrorMessageBox = styled.div`
  text-align: center;
  color: var(--color-warning);
  border: 1px dashed var(--color-warning);
  height: 100%;
`;

export const HoverHighlight = styled.div`
background-color: var(--color-databox-bg);
&:hover {
  background-color: var(--color-row-hover);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.6);
  transition: all 0.3s;
}
box-shadow: 0px 0px 8px rgba(0, 0, 0, 0);
transition: all 0.3s;
`;

export const HoverEnlarge = styled.div`
${HoverHighlight}:hover & {
  transform: scale(${props => (props.scaleFactor ? props.scaleFactor : 1.15)});
  transition: all 0.3s;
}
transition: all 0.3s;
`;

export const HorizontalLoader = styled.div`
  width: 5px;
  height: 5px;
  top: calc(50%);
  left: calc(50%);
  transform: translate(-50%, -50% );
  border-radius: 50%;
  background-color: var(--color-white);
  box-shadow: 10px 0 var(--color-white), -10px 0 var(--color-white);
  position: absolute;
  animation: flash 0.5s ease-out infinite alternate;
  zIndex: 9;
`;

export const HeaderWrap = styled.header`
  position: fixed;
  top: 0;
  height: var(--height-header);
  width: 100vw;
  min-width: 320px;
  text-align: left;
  background-color: var(--color-header-bg);
  color: var(--color-header);
  padding: 0 var(--padding-header) 0 var(--padding-header);
  box-sizing: border-box;
  z-index: 98;
  display: flex;
  box-shadow: 0px 7px 5px -5px rgba(0,0,0,0.05);
  /* Sticky footer styles */
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  /* END Sticky footer styles */
  #siteLogo {
    margin: var(--padding-header) 0px var(--padding-header) 0px;
    font-size: 18px;
    height: calc(100% - var(--padding-header) - var(--padding-header));
    text-decoration: none;
    display: flex;
    transition: all 0.2s ease 0s;
  }
`;

export const Logo = styled.div`
  ${props => (props.type === 'graphic' ? `
    height: 50px;
    width: 40px;
    transition: all 0.2s ease 0s;
    &&::after {
      content: '';
      display: block;
      width: 100%;
      padding-bottom: 129%;
      min-width: 40px;
      background: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20viewBox%3D%220%200%20222.963%20184.877%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3Cstyle%3E.cls-1%7Bfill%3A%23b49b56%3B%7D.cls-2%7Bfill%3A%23bdad81%3B%7D%3C%2Fstyle%3E%0A%20%20%3C%2Fdefs%3E%0A%20%20%3Cpath%20class%3D%22cls-2%22%20d%3D%22M124.27%2C92.25c-7.32-17.16-9-35.85-9-58.94H99.5c0%2C23.28-2.91%2C42.43-8.85%2C58.94C78.87%2C125%2C62.15%2C148.5%2C5%2C181.23H26c52.84-30.32%2C65.9-59.68%2C75.17-89%2C2.39-7.56%2C4.48-13.78%2C6.3-19.72%2C1.74%2C6.37%2C3.78%2C12.93%2C6.2%2C19.72%2C7.24%2C20.31%2C18.58%2C41.63%2C51.6%2C64l16.85%2C0C145.7%2C132%2C133.19%2C113.16%2C124.27%2C92.25Z%22%2F%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M189.41%2C3C140.61%2C28%2C122.68%2C63%2C113.66%2C92.25c-2.44%2C8-4.5%2C14.11-6.3%2C20a171.22%2C171.22%2C0%2C0%2C0-6.36-20C93%2C71.61%2C81%2C48.69%2C49.44%2C28.06h-17c37.15%2C24.7%2C49.21%2C42.78%2C58%2C64.19%2C6.86%2C16.79%2C8.8%2C36.18%2C8.8%2C58.7h16.22c0-23.39%2C2.87-42.18%2C8.82-58.7C136.05%2C59.53%2C152.62%2C35.74%2C209.71%2C3Z%22%2F%3E%0A%3C%2Fsvg%3E") center center / auto 82% no-repeat transparent;
      margin-left: 0.25em
    }
  ` : ``)}
  ${props => (props.type === 'wordMark' ? `
    opacity: 1;
    display: flex;
    transition: all 0.2s ease 0s;
    &&::after {
      content: '';
      display: block;
      width: 100%;
      padding-bottom: 25%;
      background: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20viewBox%3D%220%200%20727.402%20181.842%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3Cstyle%3E.cls-1%7Bfill%3A%23b49b56%3B%7D.cls-2%7Bfill%3A%23bdad81%3B%7D%3C%2Fstyle%3E%0A%20%20%3C%2Fdefs%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M%20488.16%2041.09%20C%20453.7%2073.34%20449.9%20118.49%20449.9%20118.49%20C%20447.69%2094.77%20440.02%2065.98%20414.9%2041.09%20L%20394.7%2041.09%20C%20411.17%2053.62%20436.37%2084.02%20436.37%20142.69%20L%20454.73%20142.69%20C%20454.73%2088.09%20484.55%2050.58%20500.27%2041.09%20Z%22%2F%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M%20542.41%2071.29%20C%20542.41%2040.64%20538.41%2041.09%20538.41%2041.09%20L%20561.41%2041.09%20C%20561.41%2041.09%20557.24%2044.09%20557.24%2071.29%20L%20557.24%20110.68%20C%20557.24%20139.81%20561.41%20142.68%20561.41%20142.68%20L%20538.41%20142.68%20C%20538.41%20142.68%20542.41%20138.52%20542.41%20110.68%20Z%22%2F%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M%20313.62%2089.9%20C%20334.12%2089.9%20343.19%2077.82%20343.19%2066.96%20C%20343.19%2055.84%20338.9%2046.46%20316.92%2046.46%20L%20309.15%2046.46%20L%20309.15%20113.31%20C%20309.17%20123.37%20311.083%20133.337%20314.79%20142.69%20L%20291.47%20142.69%20C%20291.47%20142.69%20295.12%20133.29%20295.12%20114.94%20L%20295.12%2071.64%20C%20295.12%2051.79%20291.47%2041.09%20291.47%2041.09%20L%20318.13%2041.09%20C%20343.33%2041.09%20359.28%2049.4%20359.28%2066.96%20C%20359.28%2080.36%20348.1%2087.6%20332.55%2091.89%20C%20339.93%20101.45%20355.01%20122.71%20375.14%20142.69%20L%20353.24%20142.69%20C%20339.79%20119.69%20313.62%2089.9%20313.62%2089.9%22%2F%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M%20162.71%2088.1%20C%20162.71%20119.87%20177.59%20139.17%20199.97%20139.17%20C%20218.34%20139.17%20233.97%20125.36%20233.97%2095.88%20C%20233.97%2064.11%20219.09%2044.81%20196.57%2044.81%20C%20178.34%2044.81%20162.66%2058.62%20162.66%2088.1%20M%20251.17%2092%20C%20251.17%20123%20226.91%20145.07%20198.36%20145.07%20C%20169.28%20145.07%20145.56%20122.96%20145.56%2092%20C%20145.56%2061.04%20169.82%2038.92%20198.36%2038.92%20C%20227.31%2038.92%20251.17%2061.04%20251.17%2092%22%2F%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M%20111.52%20121.71%20L%20111.52%20121.71%20L%20105.89%20140%20C%2095.384%20143.465%2084.382%20145.185%2073.32%20145.09%20C%2042.5%20145.09%2019.71%20120.97%2019.71%2092.02%20C%2019.71%2063.07%2043.03%2038.94%2074.71%2038.94%20C%2089.32%2038.94%2098.71%2041.49%20105%2043.64%20L%20109.43%2061.5%20C%20100.775%2051.045%2087.883%2045.028%2074.31%2045.11%20C%2055.55%2045.11%2036.92%2058.38%2036.92%2088%20C%2036.92%20118.42%2053%20138.93%2077.53%20138.93%20C%2090.954%20138.943%20103.582%20132.559%20111.53%20121.74%22%2F%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M%20665%20100.92%20L%20650%2060.45%20L%20635.38%20100.92%20Z%20M%20609.74%20142.69%20C%20609.74%20142.69%20614.87%20135.9%20620.09%20121.93%20L%20643.09%2060.45%20C%20646.93%2049.62%20643.9%2041.13%20643.9%2041.13%20L%20657.33%2041.13%20L%20692.18%20131.72%20C%20694.27%20136.94%20700.38%20142.72%20700.38%20142.72%20L%20674.82%20142.72%20C%20674.82%20142.72%20678.48%20136.97%20676.26%20130.84%20L%20667.52%20107.6%20L%20633.06%20107.6%20L%20627.84%20122.22%20C%20623.27%20134.49%20627.19%20142.72%20627.19%20142.72%20Z%22%2F%3E%0A%3C%2Fsvg%3E") left center / 81% auto no-repeat transparent;
      min-width: 200px;
      margin-left: 0.5em;
    }
  ` : ``)}
`;

export const MinMaxButton = styled.button`
  position: relative;
  top: 0px;
  width: 16px;
  height: 16px;
  background: ${props => (props.$bgColor ? props.$bgColor : `var(--color-bg-alt)`)};
  border-radius: 100%;
  border: none;
  margin: 0px 5px 0px 0px;
  padding: 0;
  cursor: pointer;
  &:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 16px;
    height: 16px;
    content: '';
    display: block;
    background-size: 16px;
    background-repeat: no-repeat;
    transition: clip-path 0.2s;
    background: ${props => (props.color ? props.color : `var(--color-primary)`)};;
    transition: 0.2s;
  }
  &:before {
    ${props => (props.$minimized ? `
      clip-path: polygon(15% 45%, 45% 45%, 45% 15%, 55% 15%, 55% 45%, 85% 45%, 85% 55%, 55% 55%, 55% 85%, 45% 85%, 45% 55%, 15% 55%);
    ` : `
      clip-path: polygon(15% 45%, 28% 45%, 45% 45%, 55% 45%, 72% 45%, 85% 45%, 85% 55%, 72% 55%, 55% 55%, 45% 55%, 28% 55%, 15% 55%);
    `)}
  }
`;

export const SideNavigation = styled.div`
  .sideNavNav {
    position: relative;
    background-color: ${props => (props.$isOpen ? 'var(--color-bg)' : 'var(--color-bg)')};;
    margin-right: 21px;
    width: 100%;
    height: 100%;
    max-width: ${props => (props.$isOpen ? '150px' : '5px')};
    transition: all 0.2s;
    border-radius: var(--radius-main);
    .spacer {
      width: 150px;
    }
  }
  nav {
    padding-top: 26px;
    overflow: hidden;
    transition: opacity 0.2s;
    opacity: ${props => (props.$isOpen ? '1' : '0')};
    border-radius: var(--radius-main);
    background: ${props => (props.$type === 'white' ? 'var(--color-bg)' : 'var(--color-bg-alt)')};
    ul {
      padding: 0;
      margin: 0;
      li {
        padding: 0 10px;
        button {
          display: block;
          width: 100%;
          text-align: left;
        }
        &:hover {
          button {
            font-weight: bold;
          }
        }
        &.active {
          background: ${props => (props.$type === 'white' ? 'var(--color-bg-alt)' : 'var(--color-bg)')};
        }
      }
    }
  }
  .navWrap {
    transition: all 0.2s;
    background: ${props => (props.$type === 'white' ? 'var(--color-bg)' : 'var(--color-bg-alt)')};
    max-width: ${props => (props.$isOpen ? '150px' : '5px')};
    width: 100%;
    border-radius: var(--radius-main) 0 var(--radius-main) var(--radius-main);
    &.sticky {
      position: fixed;
      top: var(--height-header);
      z-index: 10;
    }
  }
  .sideNavToggle {
    cursor: pointer;
    padding: 0;
    width: 26px;
    height: 26px;
    position: absolute;
    top: 0;
    right: -26px;
    border: none;
    border-radius: 0 50% 50% 0;
    background: ${props => (props.$type === 'white' ? 'var(--color-bg)' : 'var(--color-bg-alt)')};
  }
  @media only screen and (max-width: 615px) {
    .sideNavNav {
      display: none;
    }
  }
`;

export const CropBox = styled.div`
  .cropContainer, .croppedThumbnail {
    width: ${props => (props.width ? props.width : 200)}px;
    height: ${props => (props.height ? props.height : 274)}px;
    position: relative;
    border-radius: var(--radius-main);
    overflow: hidden;
  }
  .croppedThumbnail {
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    button {
      margin: 10px;
    }
  }
  .sliderContainer {
    width: 50%;
    display: flex;
    .rangeTitle {
      position: relative;
      text-align: left;
      height: 18px;
      margin-bottom: 16px;
    }
    .rangeTitle .icon {
      position: absolute;
    }
    .rangeTitle .icon {
      left: 0;
      top: -3px;
    }
    .rangeSlider {
      width: 100%;
      pointer-events: none;
      border-radius: 5px;
      opacity: 0.7;
      -webkit-transition: .2s;
      transition: opacity .2s;
      box-sizing: border-box;
      background-clip: padding-box;
      padding: 0;
      margin: 14px 0;
      font: inherit;
      color: inherit;
      background: transparent;
      border: none;
      vertical-align: top;
      outline: none;
      line-height: 1;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-image: -webkit-gradient(linear, left top, left bottom, from(#0076ff), to(#0076ff));
      background-image: linear-gradient(#0076ff, #0076ff);
      background-position: left center;
      background-size: 0% 2px;
      background-repeat: no-repeat;
      background: #a4aab3;
      height: 2px;
      position: relative;
      z-index: 1;
      width: 100%;
    }
  }
  .rangeSlider:hover {
    opacity: 1;
  }
  .rangeSlider::-webkit-slider-thumb {
    pointer-events: auto;
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--color-bg);
    border: 2px solid #c6c8cc;
    cursor: pointer;
    box-shadow: 0 3px 2px 0 rgba(0,0,0,.35);
  }
  .rangeSlider::-moz-range-thumb {
    pointer-events: auto;
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--color-bg);
    border: 2px solid #c6c8cc;
    cursor: pointer;
    box-shadow: 0 3px 2px 0 rgba(0,0,0,.35);
  }
  .rangeSlider.active::-webkit-slider-thumb, .rangeSlider:active::-webkit-slider-thumb {
    width: 30px;
    height: 30px;
    border: 4px solid #4d88ff;
  }
  .rangeSlider.active::-moz-range-thumb, .rangeSlider:active::-moz-range-thumb {
    width: 30px;
    height: 30px;
    border: 4px solid #4d88ff;
  }
`;

export const StyledSelectDateRange = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  width: fit-content;
  .dropdowns-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 0.3em;
  }
  .inputs-wrapper {
    display: flex;
    flex-wrap: wrap;
    label {
      flex: 1;
      width: 120px;
    }
    ${props => (props.$boxStyle === 'inside' ? `
    input#fromDate {
      border-right-color: var(--color-grey);
    }
    input#toDate {
      border-left-color: var(--color-grey);
    }
    ` : `
    gap: 0.3em;
    `)}
  }
`;

export const StyledMiniBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
  position: relative;
  .mini-report {
    flex: 1;
    border: 2px solid transparent;
    color: var(--color-primary);
    background-color: ${props => (props.fill ? props.fill : 'var(--color-bg)')};
    border-radius: var(--radius-main);
    box-shadow: 0px, 1px, 5px, 0, var(--color-hr);
    display: flex;
    flex-direction: column;
    ${props => (props.$greyscale ? `
    ` : `
      padding: 0.3em;
    `)}
    .title {
      flex: 1;
      color: var(--color-text);
      line-height: 1.5;
      font-size: 0.8em;
      text-align: center;
      ${props => (props.$greyscale ? `
        background-color: var(--color-grey);
        font-weight: 600;
        padding: 0.2em 0;
        border-top-left-radius: var(--radius-small);
        border-top-right-radius: var(--radius-small);
      ` : `
      `)}
    }
    .value {
      flex: 1;
      font-size: 1.3em;
      vertical-align: middle;
      text-align: center;
      ${props => (props.$greyscale ? `
        background-color: var(--color-quinary);
        color: var(--color-text);
        border-bottom-left-radius: var(--radius-small);
        border-bottom-right-radius: var(--radius-small);
      ` : `
        color: hsl(var(--color-secondary-hue), var(--color-secondary-saturation), calc(var(--color-secondary-lightness) + 12%));
      `)}
    }
    ${props => (props.$hasCallback ? `
      &:hover {
        border: 2px solid var(--color-primary);
        cursor: pointer;
        .title {
          color: var(--color-primary);
        }
      }
    ` : `
    `)}
  }
`;

export const StyledDragAndDropRankedList = styled.div`
  .component-label {
    display: flex;
    flex-wrap: wrap;
    line-height: 1.5;
    font-size: 1.2rem;
    min-height: 24px;
    label {
      display: block;
      flex: 1;
    }
  }
  .DraggableItems {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    .ranked-list-item {
      ${props => (props.$boxStyle === 'inside' && !props.disabled ? `
        border-top: 1px solid var(--color-grey);
        &:hover {
          background: var(--color-row-hover) !important;
        }
      ` : `
      `)}
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      padding-left: 2em;
      width: 100%;
      .rank {
        font-size: 0.9em;
        width: 32px;
      }
      .component-wrapper {
        flex: 1;
      }
    }
    ${props => (props.$boxStyle === 'inside' ? `
      gap: 0;
      > div:nth-child(even) .ranked-list-item {
        background-color: var(--color-row-even);
        > label {
          background-color: transparent;
          padding: 0;
        }
      }
    ` : `
    `)}
  }
  ${props => (props.$boxStyle === 'inside' ? `
    width: 100%;
    background-color: var(--color-bg);
    border: 1px solid black;
    .component-label {
      min-height: 14px;
      padding: 4px;
      margin-left: 0;
      margin-right: 0;
      margin-top: 0;
      margin-bottom: 0;
      label {
        color: hsl(var(--color-text-hue), var(--color-text-saturation), calc(var(--color-text-lightness) + 25%));
      }
    }
    .ranked-list-item.invalid {
      color: var(--color-warning);
      background-color: var(--color-warning-bg) !important;
      input {
        background-color: var(--color-warning-bg) !important;
      }
    }
    .ranked-list-item.valid {
      background-color: var(--color-healthy-bg) !important;
    }
    &.list-valid {
      .DraggableItems .ranked-list-item {
        background-color: var(--color-healthy-bg) !important;
      }
    }
  ` : `
  `)}
  ${props => (props.$boxStyle === 'inside' && !props.disabled ? `
    input {
      border-left-color: var(--color-grey) !important;
      border-top-color: var(--color-grey) !important;
    }
    &.list-valid {
      border-color: hsl(174, 100%,calc(14% + 10%));
      background-color: var(--color-healthy-bg) !important;
    }
    &.list-invalid {
      border-color: var(--color-warning);
      background-color: var(--color-warning-bg);
      .DraggableItems .ranked-list-item {
        background-color: var(--color-warning-bg) !important;
        .combo-label-wrapper {
          .dropList__control {
            background-color: inherit;
            .dropList__value-container {
              background-color: inherit;
            }
          }
        }
      }
    }
    ` : `
  `)}
  ${props => (props.$boxStyle === 'inside' && props.disabled ? `
    .component-label label, .rank {
      color: var(--color-light-label);
    }
    border-color: var(--color-light-label);
    background-color: var(--color-disabled) !important;
    .ranked-list-item {
      background-color: var(--color-disabled) !important;
    }
  ` : `
  `)}
`;
